import { BackingStep, ClosingStep, CompositionStep, CoverStep } from "./detail-steps";

export interface ProductDetailWizardBodyProps {
  step: number;
}

/**
 * Qué paso de los detalles se pinta.
 *
 * Los índices salen del orden de `PRODUCT_DETAIL_STEPS`; se escriben aquí
 * como constantes con nombre por lo mismo que en el asistente de alta:
 * insertar un paso en medio renumeraría todo en silencio y un paso
 * pasaría a pintar el de al lado sin que nada dejara de compilar.
 */
const STEP_COVER = 0;
const STEP_COMPOSITION = 1;
const STEP_BACKING = 2;
const STEP_CLOSING = 3;

export function ProductDetailWizardBody({ step }: ProductDetailWizardBodyProps) {
  switch (step) {
    case STEP_COVER:
      return <CoverStep />;
    case STEP_COMPOSITION:
      return <CompositionStep />;
    case STEP_BACKING:
      return <BackingStep />;
    case STEP_CLOSING:
      return <ClosingStep />;
    default:
      return null;
  }
}
